import { PrismicLinkProps } from '@prismicio/react';
import cx from 'classnames';

import PrismicConditionalLink from '../PrismicConditionalLink';

type LinkProps = PrismicLinkProps & {
  className?: string;
  onClick?: () => void;
};

export default function Link({
  field,
  children,
  className,
  onClick
}: LinkProps) {
  const classes = cx(
    'text-tui-sm font-semibold leading-[135%] tracking-[-0.03em] underline hover:text-secondary-500 lg-tui:text-tui-base lg-tui:leading-[125%]',
    {}
  );

  return (
    <div className={`${classes} ${className}`}>
      <PrismicConditionalLink field={field} onClick={onClick}>
        {children}
      </PrismicConditionalLink>
    </div>
  );
}
